export default __webpack_public_path__ + "static/media/vire11.e5125197.jpg";